export enum ContentType {
	BrownCard = "BrownCard",
	CKEditor = "CKEditor",
	Gallery = "Gallery",
}
